/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AiConfigsExperimentEnabledPeriodRep,
  AiConfigsExperimentEnabledPeriodRep$inboundSchema,
  AiConfigsExperimentEnabledPeriodRep$Outbound,
  AiConfigsExperimentEnabledPeriodRep$outboundSchema,
} from "./aiconfigsexperimentenabledperiodrep.js";

export type AiConfigsExperimentEnvironmentSettingRep = {
  startDate?: number | undefined;
  stopDate?: number | undefined;
  enabledPeriods?: Array<AiConfigsExperimentEnabledPeriodRep> | undefined;
};

/** @internal */
export const AiConfigsExperimentEnvironmentSettingRep$inboundSchema: z.ZodType<
  AiConfigsExperimentEnvironmentSettingRep,
  z.ZodTypeDef,
  unknown
> = z.object({
  startDate: z.number().int().optional(),
  stopDate: z.number().int().optional(),
  enabledPeriods: z.array(AiConfigsExperimentEnabledPeriodRep$inboundSchema)
    .optional(),
});
/** @internal */
export type AiConfigsExperimentEnvironmentSettingRep$Outbound = {
  startDate?: number | undefined;
  stopDate?: number | undefined;
  enabledPeriods?:
    | Array<AiConfigsExperimentEnabledPeriodRep$Outbound>
    | undefined;
};

/** @internal */
export const AiConfigsExperimentEnvironmentSettingRep$outboundSchema: z.ZodType<
  AiConfigsExperimentEnvironmentSettingRep$Outbound,
  z.ZodTypeDef,
  AiConfigsExperimentEnvironmentSettingRep
> = z.object({
  startDate: z.number().int().optional(),
  stopDate: z.number().int().optional(),
  enabledPeriods: z.array(AiConfigsExperimentEnabledPeriodRep$outboundSchema)
    .optional(),
});

export function aiConfigsExperimentEnvironmentSettingRepToJSON(
  aiConfigsExperimentEnvironmentSettingRep:
    AiConfigsExperimentEnvironmentSettingRep,
): string {
  return JSON.stringify(
    AiConfigsExperimentEnvironmentSettingRep$outboundSchema.parse(
      aiConfigsExperimentEnvironmentSettingRep,
    ),
  );
}
export function aiConfigsExperimentEnvironmentSettingRepFromJSON(
  jsonString: string,
): SafeParseResult<
  AiConfigsExperimentEnvironmentSettingRep,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      AiConfigsExperimentEnvironmentSettingRep$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'AiConfigsExperimentEnvironmentSettingRep' from JSON`,
  );
}
